import focusFirstLine from './commands/focusFirstLine';
import makeOnKeyDown from './handlers/onKeyDown';
export default function FirstLinePlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$focusPrevious = _ref.focusPrevious,
      focusPrevious = _ref$focusPrevious === void 0 ? function (object) {} : _ref$focusPrevious;

  return [{
    commands: {
      focusFirstLine: focusFirstLine
    },
    onKeyDown: makeOnKeyDown({
      focusPrevious: focusPrevious
    })
  }];
}